import { parseHex } from './contrast'

/**
 * Teinte d'accent SUGGÉRÉE à partir de la primaire.
 *
 * L'accent reste saisi par l'organisation : sa charte a le plus souvent déjà une
 * seconde couleur, et la dériver d'office donnait une teinte cohérente mais qui
 * n'était pas la sienne. Cette fonction n'alimente donc qu'un bouton
 * « suggérer », pour l'organisme qui n'en a pas et qui préfère un point de
 * départ à une page blanche.
 *
 * On éclaircit fortement vers le blanc : l'accent recouvre les fonds de survol
 * et les états actifs, il doit rester proche du fond, pas de la marque.
 */
export function deriveAccent(primary: string): string | null {
  const rgb = parseHex(primary)
  if (!rgb) return null
  // 88 % de blanc : assez teinté pour qu'on reconnaisse la marque, assez clair
  // pour que du texte foncé reste lisible par-dessus.
  const mixed = rgb.map(channel => Math.round(channel + (255 - channel) * 0.88))
  return `#${mixed.map(c => c.toString(16).padStart(2, '0')).join('')}`.toUpperCase()
}

/**
 * Palette de départ : des primaires qui passent AA sur les deux thèmes.
 *
 * Proposer un point de départ correct évite la page blanche devant un
 * sélecteur de couleur, qui est le moment où l'on choisit mal.
 */
export const STARTER_COLORS = [
  '#1F4FD8',
  '#0F766E',
  '#7C3AED',
  '#B91C1C',
  '#B45309',
  '#111827',
] as const
